import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ItemsState } from "../../redux/state";
import { List, makeStyles, Paper } from "@material-ui/core";
import { ListItem } from "@ofqual/portal-components/components/List/ListItem";
import { FindInPage } from "@material-ui/icons";
import { ApplicationStatus, ExpertsApplyModel } from "../../domain/ExpertsApplyFormModel";
import {formatUtcDate, standardDateFormats} from "@ofqual/portal-core/core/utils/dateUtils";
import { authSelector } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { UserRole } from "../../domain/userRole";

const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
    active: {
        ...theme.list.itemPrimary,
    },
}));

export const ItemsList: React.FC<{ state: ItemsState }> = ({ state }) => {
    
    const classes = useStyles();
    const { response } = state;
    const history = useHistory();
    const { pathname, search } = useLocation();
    const navigate = (id: string) => history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search });
    const { roles } = useSelector(authSelector);

    return (
        <>
            <Paper>
                <List disablePadding>
                    {response.data.map((item) => (
                        <React.Fragment key={item.id}>
                            <ListItem
                                button
                                alignItems="flex-start"
                                onClick={() => navigate(item.id)}
                                divider
                                className={classes.active}
                                data-test="row"
                                Icon={FindInPage}
                                primaryText={item.personalDetails.fullName}
                                reference={item.referenceNumber}
                                secondaryDetails={roles.includes(UserRole.OfqualExpertsCommissioner) ?  secondaryListCommissioners(item) : secondaryListAdminEvaluators(item)}
                                chipTexts={[
                                    {
                                        text: `Status: ${ApplicationStatus[item.applicationStatus]}`,
                                    },
                                ]}
                            ></ListItem>
                        </React.Fragment>
                    ))}
                </List>
            </Paper>
        </>
    );
};

const secondaryListAdminEvaluators = (item: ExpertsApplyModel) =>
[
        {
            heading: "Date Received",
            value: `${formatUtcDate(
                item.submittedDate,
                standardDateFormats.DATE_TIME
            )}`
        },
        {
            heading: "Date Approved",
            value: item.approvedDate ? `${formatUtcDate(
                item.approvedDate,
                standardDateFormats.DATE_TIME
            )}` : "Not provided"
        },
        {
            heading: "Renewal Date",
            value: item.approvedDate ? `${formatUtcDate(
                item.renewalDate,
                standardDateFormats.DATE_TIME
            )}` : "Not provided"
        }
    ]

const secondaryListCommissioners = (item: ExpertsApplyModel) =>
[
        {
            heading: "Date Received",
            value: `${formatUtcDate(
                item.submittedDate,
                standardDateFormats.DATE_TIME
            )}`
        },
        {
            heading: "Date Approved",
            value: item.approvedDate ? `${formatUtcDate(
                item.approvedDate,
                standardDateFormats.DATE_TIME
            )}` : "Not provided"
        },
        {
            heading: "Renewal Date",
            value: item.approvedDate ? `${formatUtcDate(
                item.renewalDate,
                standardDateFormats.DATE_TIME
            )}` : "Not provided"
        },
        {
            heading: "Conficts of interest",
            value : item.conflictInterests.length > 0 ? "Yes": "No"
        }
]